import { hotelLink } from './hotelLink';

// Central affiliate deep links for destination pages.
//
// All Travelpayouts links here are its fixed `*.tp.st` short links, because
// every partner we use is "ready-made links only" — the dashboard's link
// generator refuses custom targets for them. For a partner that DOES accept
// arbitrary targets, build the wrapper instead (marker 444230, campaign_id 100,
// trs 236621): `https://tp.media/r?campaign_id=100&marker=444230&p=<PROGRAM_ID>
// &trs=236621&u=<encoded url>`. Aviasales is p=4114. Program ids come from the
// generator's "Full link" toggle. See helpers/hotelLink.js for the same recipe.
//
// Verified against the Travelpayouts dashboard on 2026-08-04. Booking.com,
// Trip.com, Agoda, Expedia, Hotels.com, Vio.com and Viator are all still behind
// TP's traffic gate, so there is no general-hotel link here — helpers/hotelLink.js
// stays the single flip point for that slot.

// GetYourGuide runs on our direct partner account rather than Travelpayouts.
// Its search takes free text, so this is the one partner that can actually be
// pointed at the destination the reader is looking at.
export const GYG_PARTNER_ID = '0NCPEPQ';

export const activitiesLink = place =>
  `https://www.getyourguide.com/s/?q=${encodeURIComponent(
    place,
  )}&partner_id=${GYG_PARTNER_ID}&utm_medium=online_publisher`;

// Kiwi.com. Its 3% is 3% of the booking value, where Aviasales' headline 50%
// is 50% of the network's own thin margin on a ticket — so Kiwi pays more per
// booking despite the smaller number. Neither can carry a destination: Kiwi is
// ready-made-only, and Aviasales' search URLs need IATA codes we don't store.
export const flightsLink = () => 'https://kiwi.tp.st/B2ad4zOT';

// DiscoverCars: 23–54% commission, 365-day cookie, and the only program that
// has ever converted for us.
export const carRentalLink = () => 'https://discovercars.tp.st/yQKbm54Z';

// Accommodation falls back to Hostelworld until a general hotel program clears
// TP's traffic gate; relighting hotelLink() upgrades this automatically.
export const staysLink = place =>
  hotelLink(place) || 'https://hostelworld.tp.st/ANPDOIh2';
